<template>
  <div class="familyApply">
    <div
      class="card"
      :class="item.sex === '1' ? 'woman' : 'man'"
      @click="applyService(item)"
      v-for="item in cardList"
      :key="item.id"
    >
      <div class="avatar">
        <img
          v-if="item.sex === '0'"
          src="@/assets/images/youngman.png"
          alt=""
        />
        <img v-else src="@/assets/images/youngwoman.png" alt="" />
      </div>
      <div class="info" :class="item.sex === '1' ? 'woman' : 'man'">
        <div class="top">
          <span>{{ item.fullName }}</span>
          <span>{{ item.idCard | GetAge }}</span>
          <span>{{ item.myRelationName }}</span>
        </div>
        <div class="bot">{{ item.areaCodeLevel | transCommittee }}</div>
      </div>
    </div>

    <div class="addFamily" @click="addFamily">
      <div class="word">新增家人</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getFamilyInfoList } from "@/api/user.js";
import { areaCode } from "@/common/constants.js";
export default {
  name: "FamilyApply",
  data() {
    return {
      cardList: []
    };
  },
  methods: {
    // 获取家人信息
    async FamilyInfo() {
      const { data } = await getFamilyInfoList({
        areaCode,
        openId: this.openId
      });
      this.cardList = data;
    },
    applyService(item) {
      this.$router.push({ name: "applyService", query: item });
    },
    addFamily() {
      this.$router.push("addFamily");
    }
  },
  computed: {
    ...mapState("user", ["userInfo", "openId"])
  },
  mounted() {
    this.FamilyInfo();
  }
};
</script>

<style lang="scss" scoped>
.familyApply {
  .card {
    display: flex;
    margin: 0 auto;
    margin-top: 22px;
    width: 335px;
    height: 100px;
    opacity: 1;
    background: #e8f4fd;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 0px rgba(152, 228, 255, 0.3);

    &.woman {
      background-color: #fff2ea;
    }
    .avatar {
      img {
        width: 62px;
        height: 76px;
        opacity: 1;
        margin-left: 15px;
        margin-top: 12px;
      }
    }
    .info.man {
      margin-left: 20px;
      .top {
        padding-top: 17px;

        span {
          opacity: 0.9;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #024154;
          &:nth-child(1) {
            margin-right: 27px;
            width: 48px;
            display: inline-block;
            text-align: left;
          }
          &:nth-child(2) {
            margin-right: 95px;
          }
        }
      }
      .bot {
        padding-top: 24px;
        opacity: 0.9;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: right;
        color: #17272c;
      }
    }
    .info.woman {
      margin-left: 20px;
      .top {
        padding-top: 17px;

        span {
          opacity: 0.9;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Bold;
          font-weight: 700;
          text-align: center;
          color: #543302;
          &:nth-child(1) {
            margin-right: 27px;
            width: 48px;
            display: inline-block;
            text-align: left;
          }
          &:nth-child(2) {
            margin-right: 95px;
          }
        }
      }
      .bot {
        padding-top: 24px;
        opacity: 0.9;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: right;
        color: #543302;
      }
    }
  }
  .addFamily {
    margin: 0 auto;
    width: 335px;
    height: 100px;
    opacity: 1;
    background: url("~@/assets/images/add.png") #ffedbb no-repeat center 15px;
    border-radius: 8px;
    box-shadow: 0px 3px 6px 0px rgba(182, 148, 69, 0.3);
    margin-top: 24px;
    .word {
      height: 20px;
      opacity: 0.9;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Bold;
      font-weight: 700;
      text-align: center;
      color: #ffac69;
      line-height: 170px;
    }
  }
}
</style>
